// src/utils/urlParams.js
// Utility to extract user info and JWT tokens from URL params, store in localStorage, and clean up URL

/* ---------------------- Helpers ---------------------- */

const storeIfPresent = (key, value) => {
  if (value) {
    localStorage.setItem(key, value);
  }
};

const findEmailInParams = (urlParams) => {
  const possibleKeys = ['userEmail', 'email', 'UserEmail', 'Email'];

  for (const key of possibleKeys) {
    const value = urlParams.get(key);
    if (value) return value;
  }

  for (const [, value] of urlParams.entries()) {
    if (value && value.includes('@')) {
      return value;
    }
  }

  return null;
};

const storeUserInfo = (urlParams) => {
  const email = findEmailInParams(urlParams);
  const name = urlParams.get('name');
  const department = urlParams.get('department');
  const jobTitle = urlParams.get('jobTitle');
  const profilePic = urlParams.get('profile_pic_url');

  storeIfPresent('userEmail', email);
  storeIfPresent('name', name);
  storeIfPresent('department', department);
  storeIfPresent('jobTitle', jobTitle);
  storeIfPresent('profile_pic_url', profilePic);

  return email;
};

const storeTokens = (urlParams) => {
  const accessToken = urlParams.get('access_token');
  const refreshToken = urlParams.get('refresh_token');
  const token = urlParams.get('token');

  if (accessToken) {
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('token', accessToken);
    console.log('JWT access_token stored from URL parameters');
  }

  if (token) {
    localStorage.setItem('token', token);
    localStorage.setItem('access_token', token);
    console.log('JWT token stored from URL parameters');
  }

  if (refreshToken) {
    localStorage.setItem('refresh_token', refreshToken);
  }

  return { accessToken, refreshToken, token };
};

const cleanUrlIfNeeded = (email, tokens) => {
  if (email || (tokens.accessToken && tokens.refreshToken)) {
    const newUrl = window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
  }
};

/* ---------------------- Main Function ---------------------- */

export function handleUrlParams() {
  const urlParams = new URLSearchParams(window.location.search);

  const email = storeUserInfo(urlParams);
  const tokens = storeTokens(urlParams);

  cleanUrlIfNeeded(email, tokens);
}
